import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {
  AutopilotConfigurationResponse,
  CreateAutopilotConfigurationRequest,
  DestroyAutopilotConfigurationRequest,
  UpdateAutopilotConfigurationRequest,
} from './contracts'

export async function apiCreateAutopilotConfiguration(
  body: CreateAutopilotConfigurationRequest,
): Promise<AutopilotConfigurationResponse> {
  const apiData = getApiMetadata('memex-autopilot-configuration-create-api-data')
  const {data} = await fetchJSONWith<AutopilotConfigurationResponse>(apiData.url, {
    method: 'POST',
    body,
  })
  return data
}

export async function apiUpdateAutopilotConfiguration(
  body: UpdateAutopilotConfigurationRequest,
): Promise<AutopilotConfigurationResponse> {
  const apiData = getApiMetadata('memex-autopilot-configuration-update-api-data')
  const {data} = await fetchJSONWith<AutopilotConfigurationResponse>(apiData.url, {
    method: 'PUT',
    body,
  })
  return data
}

export async function apiDestroyAutopilotConfiguration(body: DestroyAutopilotConfigurationRequest): Promise<void> {
  const apiData = getApiMetadata('memex-autopilot-configuration-destroy-api-data')
  await fetchJSONWith<void>(apiData.url, {
    method: 'DELETE',
    body,
  })
}
